import React, { useContext, useEffect, useState } from "react";
import CommonProps from "./CommonProps";
import { Genre } from "../../common/model";
import { DefaultDeniedGenreIds, Genres } from "../../common/const";
import { Context } from "../../App";
import { updateUserAttribute } from "aws-amplify/auth";
import { handleError } from "../../common/utils";
import { Grid, Switch } from "@mui/material";

interface GenreNameProps {
  id: string;
  name: string[];
}

const GenreIds: React.FC<CommonProps> = (props) => {
  const { userAttributes } = props;
  const { addLoadingProcess, deleteLoadingProcess, loadUserAttributes } =
    useContext(Context);

  const [deniedGenreIds, setDeniedGenreIds] = useState<string[]>([
    ...DefaultDeniedGenreIds,
  ]);

  useEffect(() => {
    if (userAttributes) {
      if (userAttributes["custom:deniedGenreIds"]) {
        setDeniedGenreIds(JSON.parse(userAttributes["custom:deniedGenreIds"]));
      } else {
        setDeniedGenreIds([...DefaultDeniedGenreIds]);
      }
    }
  }, [userAttributes]);

  const getGenreName = (
    parentName: string[],
    genre: Genre
  ): GenreNameProps => ({
    id: genre.id,
    name: [...parentName, genre.name],
  });

  const getGenreNames = (
    parentName: string[],
    genre: Genre
  ): GenreNameProps[] => {
    const result: GenreNameProps[] = [];
    const genreName = getGenreName(parentName, genre);
    result.push(genreName);
    genre.children.forEach((child) => {
      const grandChildrenGenreNames = getGenreNames(genreName.name, child);
      result.push(...grandChildrenGenreNames);
    });
    return result;
  };

  const checkRecommendable = (id: string): boolean => {
    let result = true;
    deniedGenreIds.forEach((deniedGenreId) => {
      if (id.startsWith(deniedGenreId)) {
        result = false;
      }
      return result;
    });
    return result;
  };

  return (
    <>
      {Genres.map((genre) => {
        const genreNames = getGenreNames([], JSON.parse(JSON.stringify(genre)));
        return genreNames.map((genreName) => {
          let recommendable = checkRecommendable(genreName.id);
          return (
            <>
              <Grid container direction="row" alignItems="center" gap={2}>
                {genreName.name.join(" > ")}
                <Switch
                  checked={recommendable}
                  onChange={(_, checked) => {
                    const processId = addLoadingProcess();
                    recommendable = checked;
                    const deniedGenreIdSet = new Set(deniedGenreIds);
                    if (checked) {
                      deniedGenreIdSet.delete(genreName.id);
                    } else {
                      deniedGenreIdSet.add(genreName.id);
                    }
                    updateUserAttribute({
                      userAttribute: {
                        attributeKey: "custom:deniedGenreIds",
                        value: JSON.stringify(
                          Array.from(deniedGenreIdSet).sort()
                        ),
                      },
                    })
                      .catch((error) => {
                        handleError(error);
                      })
                      .finally(() => {
                        deleteLoadingProcess(processId);
                        loadUserAttributes();
                      });
                  }}
                />
              </Grid>
            </>
          );
        });
      })}
    </>
  );
};

export default GenreIds;
